import FilterContext from './FilterContext'
import { useContext } from 'react'

const useFilterContext = () => useContext(FilterContext)

export default useFilterContext
